/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of a transaction
 * @export
 */
export const TransactionStatus = {
    Pending: 'pending',
    Received: 'received',
    Deposited: 'deposited',
    Cleared: 'cleared',
    Voided: 'voided'
} as const;
export type TransactionStatus = typeof TransactionStatus[keyof typeof TransactionStatus];


export function instanceOfTransactionStatus(value: any): boolean {
    for (const key in TransactionStatus) {
        if (Object.prototype.hasOwnProperty.call(TransactionStatus, key)) {
            if (TransactionStatus[key as keyof typeof TransactionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TransactionStatusFromJSON(json: any): TransactionStatus {
    return TransactionStatusFromJSONTyped(json, false);
}

export function TransactionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionStatus {
    return json as TransactionStatus;
}

export function TransactionStatusToJSON(value?: TransactionStatus | null): any {
    return value as any;
}

export function TransactionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TransactionStatus {
    return value as TransactionStatus;
}

